import { Stack, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface Props {
    iconLeft: ReactNode | null
    highlighted: boolean
    outline: boolean
    header: string
    content: string
    onClick: Function
}

const HeaderText2 = ({
    iconLeft,
    highlighted,
    outline,
    header,
    content,
    onClick,
}: Props) => {
    return (
        <>
            <Stack
                sx={{
                    textDecoration: highlighted
                        ? 'underline solid white'
                        : 'none',
                    '&:hover': {
                        outline: outline ? '3px solid white' : 'none',
                        width: 'fit-content',
                    },
                }}
                direction='row'
                onClick={(e) => onClick(e)}>
                {highlighted && iconLeft}
                <Typography sx={{ fontWeight: highlighted ? '400' : '300' }}>
                    {header}
                </Typography>
            </Stack>
            <Typography
                sx={{
                    marginTop: '0.5rem',
                    fontWeight: '300',
                    marginBottom: '3rem',
                }}>
                {content}
            </Typography>
        </>
    )
}
export default HeaderText2
